import { render, staticRenderFns } from "./BulkUpdateForm.vue?vue&type=template&id=063932cd&scoped=true&"
import script from "./BulkUpdateForm.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063932cd",
  null
  
)

export default component.exports